import React, { useContext, useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { Button, Panel, Input } from "components/bootstrap";
import FormWrap from "integrations/aws/common/FormWrap";
import SkipHealthCheck from "integrations/aws/common/SkipHealthCheck";
import useFetch from "integrations/hooks/useFetch";
import { ApiRoutes } from "integrations/aws/common/Routes";
import Countdown from "integrations/aws/common/Countdown";
import { KINESIS_LOG_TYPES } from "integrations/aws/common/constants";
import { ApiContext } from "integrations/aws/context/Api";
import FormDataContext from "integrations/contexts/FormDataContext";
import Icon from "components/common/Icon";
import { toAWSRequest } from "integrations/aws/common/formDataAdapter";
const Notice = styled.span`
  display: flex;
  align-items: center;

  > span {
    margin-left: 6px;
  }
`;
const CheckAgain = styled.p`
  display: flex;
  align-items: center;

  > strong {
    margin-right: 9px;
  }
`;
const StepHealthCheck = ({ onChange, onSubmit }) => {
  const { logData, setLogData } = useContext(ApiContext);
  const { formData } = useContext(FormDataContext);
  const [pauseCountdown, setPauseCountdown] = useState(false);
  const [fetchStreamArnStatus, setStreamArnFetch] = useFetch(
    null,
    (response) => {
      onChange({ target: { name: "awsCloudwatchKinesisStreamArn", value: response.result } });
    },
    "POST",
    toAWSRequest(formData, {
      region: formData.awsCloudWatchAwsRegion.value,
      stream_name: formData.awsCloudWatchKinesisStream.value
    })
  );
  useEffect(() => {
    setStreamArnFetch(ApiRoutes.INTEGRATIONS.AWS.KINESIS.STREAM_ARN);
  }, [setStreamArnFetch]);
  useEffect(() => {
    if (fetchStreamArnStatus.error) {
    }
  }, [fetchStreamArnStatus]);
  const [logDataProgress, setLogDataUrl] = useFetch(
    null,
    (response) => {
      setLogData(response);
      onChange({ target: { name: "awsCloudWatchKinesisInputType", value: response.type } });
    },
    "POST",
    toAWSRequest(formData, {
      region: formData.awsCloudWatchAwsRegion.value,
      stream_name: formData.awsCloudWatchKinesisStream.value
    })
  );
  const checkForLogs = useCallback(() => {
    setPauseCountdown(true);
    setLogDataUrl(ApiRoutes.INTEGRATIONS.AWS.KINESIS.HEALTH_CHECK);
  }, [setPauseCountdown, setLogDataUrl]);
  useEffect(() => {
    if (!logData) {
      checkForLogs();
    }
  }, [checkForLogs, logData]);
  useEffect(() => {
    if (!logDataProgress.loading && !logDataProgress.data) {
      setPauseCountdown(false);
      setLogDataUrl(null);
    }
  }, [logDataProgress.data, logDataProgress.loading, setLogDataUrl]);
  if (!logData) {
    return /* @__PURE__ */ React.createElement(
      Panel,
      {
        bsStyle: "warning",
        header: /* @__PURE__ */ React.createElement(Notice, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning", size: "2x" }), /* @__PURE__ */ React.createElement("span", null, "We haven't received a response back from Amazon yet."))
      },
      /* @__PURE__ */ React.createElement("p", null, "Hang out for a few moments while we keep checking your AWS stream for logs. Amazon's servers parse logs every 10 minutes, so grab a cup of coffee because this may take some time!"),
      /* @__PURE__ */ React.createElement(CheckAgain, null, /* @__PURE__ */ React.createElement("strong", null, "Checking again in: ", /* @__PURE__ */ React.createElement(Countdown, { timeInSeconds: 120, callback: checkForLogs, paused: pauseCountdown })), /* @__PURE__ */ React.createElement(Button, { type: "button", bsStyle: "primary", bsSize: "sm", onClick: checkForLogs, disabled: logDataProgress.loading }, logDataProgress.loading ? "Checking..." : "Check Now")),
      /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("em", null, "Do not refresh your browser, we are continually checking for your logs and this page will automatically refresh when your logs are available.")),
      /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SkipHealthCheck, { onSubmit, onChange }))
    );
  }
  const handleSubmit = () => {
    onSubmit();
    onChange({ target: { name: "awsCloudWatchKinesisInputType", value: logData.type } });
  };
  const logTypeLabel = KINESIS_LOG_TYPES.find((type) => type.value === logData.type).label;
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Review & Finalize",
      disabled: false,
      title: "Create Kinesis Stream",
      description: /* @__PURE__ */ React.createElement("p", null, "If available, a parsed sample ", logTypeLabel, " message from the stream will be shown below.")
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "awsCloudWatchLog",
        type: "textarea",
        label: "Formatted Log Message",
        value: logData.message || "No messages found in stream.",
        rows: 10,
        disabled: true
      }
    )
  );
};
export default StepHealthCheck;
